import { createElement, CSSProperties, forwardRef } from 'react';
import { DesignTokens, renderInlineCssVars, useDesignTokens } from '../../theme';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import bundle from './NovaComponents-BusyStateIndicator-gui-icu.properties';
import { Flow } from '../Layouts/Flow';

import cx from 'classnames';
import cn from './BusyStateAnimationElement.css.json';
import './BusyStateAnimationElement.css';

const useTextLocalizer = createUseTextLocalizer(bundle);
export interface BusyStateAnimationElementProps {
  className?: string;
  style?: CSSProperties;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  tabIndex?: number;
  tokens?: () => { bg: string };
}

export const BusyStateAnimationElement = forwardRef<HTMLDivElement, BusyStateAnimationElementProps>(
  function BusyStateAnimationElement(props, ref) {
    const localize = useTextLocalizer();
    const dt = useDesignTokens();
    const animationStyle = renderInlineCssVars(
      props.tokens?.() ?? getBusyStateAnimationTokens(dt),
      'busy-state-dot'
    );

    return (
      <Flow
        spacing="s"
        tabIndex={props.tabIndex ?? 0}
        ref={ref}
        className={cx(cn.dotContainer, props.className)}
        style={{ ...animationStyle, ...props.style }}
        aria-label={props.ariaLabel ?? localize('busyStateIndicatorAnimation.default.aria')}
        aria-describedby={props.ariaDescribedBy}
        role="img"
        title={localize('busyStateIndicatorAnimation.default.tooltip.label')}
      >
        <span className={cn.first} />
        <span className={cn.second} />
        <span className={cn.third} />
      </Flow>
    );
  }
);

function getBusyStateAnimationTokens(dt: DesignTokens) {
  const tokens = dt.enableNovaTokens
    ? dt.stateStatusContentNova.informational
    : dt.stateStatusContent.informational;

  if (dt.enableNovaTokens) {
    return {
      bg: tokens.fg,
    };
  } else {
    switch (dt.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        // from https://gitlab.sas.com/dvr/html/resource-archive/blob/master/specs/object-status.pdf
        return { bg: dt.c.hcBusy };
    }
    return { bg: tokens.fg };
  }
}
